// 📝 설문 문항 정의 (클라) — 🔴 서버 `server/core/surveySchema.ts` 와 id·형식·선택지 키가 같아야 한다(서버가 검증, 어긋나면 400).
//   문구는 로케일 `survey.q.<id>`(질문) · `survey.o.<id>.<key>`(선택지) · `survey.sec.<a|b|c|d>`(섹션).
//   화면 순서 = 이 배열 순서(섹션별 필터). v2(2026-09-11): q16~q29 추가 + 섹션 D(효과·방향). id 는 추가만, 기존 id 유지.
export type SurveyQType = 'multi' | 'single' | 'rating' | 'nps' | 'text';
export type SurveySection = 'a' | 'b' | 'c' | 'd';
export interface SurveyQuestion {
	id: string; type: SurveyQType; section: SurveySection; required: boolean;
	options?: readonly string[]; max?: number; skippable?: boolean; maxLen?: number; other?: boolean;
	/** rating 양끝 라벨 — 기본 'sat'(불만~만족), 'agree'(전혀 아님~매우 그렇다) */
	scale?: 'sat' | 'agree';
}

/** q3(자주 쓰는 기능)·q19(몰라서 안 쓰는 기능) 공용 선택지 — 관리자 '기능 인지 갭' 표가 같은 키로 대비 */
export const FEATURE_OPTIONS = ['dm', 'topic', 'thread', 'files', 'translate', 'search', 'calendar', 'project', 'drive', 'voice', 'ai', 'feeds'] as const;

export const SURVEY_QUESTIONS: readonly SurveyQuestion[] = [
	// A. 사용 현황
	{ id: 'q1', type: 'multi', section: 'a', required: true, options: ['desktop', 'web', 'android', 'iphone'] },
	{ id: 'q16', type: 'single', section: 'a', required: true, options: ['lt1m', 'm1_3', 'm3_6', 'm6p'] },
	{ id: 'q2', type: 'single', section: 'a', required: true, options: ['lt30', 'h1', 'h3', 'h3p'] },
	{ id: 'q17', type: 'multi', section: 'a', required: true, max: 3, options: ['team', 'crossdept', 'overseas', 'partner', 'notice', 'personal'] },
	{ id: 'q18', type: 'single', section: 'a', required: true, options: ['never', 'monthly', 'weekly', 'daily'] },
	{ id: 'q3', type: 'multi', section: 'a', required: true, max: 5, options: FEATURE_OPTIONS },
	{ id: 'q19', type: 'multi', section: 'a', required: false, options: [...FEATURE_OPTIONS, 'none'] },
	{ id: 'q20', type: 'single', section: 'a', required: true, options: ['jandi', 'kakao', 'email', 'phone', 'other'] },
	// B. 만족도
	{ id: 'q4', type: 'rating', section: 'b', required: true },
	{ id: 'q5', type: 'rating', section: 'b', required: true },
	{ id: 'q23', type: 'single', section: 'b', required: true, options: ['none', 'few', 'weekly', 'daily'] },
	{ id: 'q6', type: 'rating', section: 'b', required: true },
	{ id: 'q7', type: 'rating', section: 'b', required: true },
	{ id: 'q8', type: 'rating', section: 'b', required: true },
	{ id: 'q9', type: 'rating', section: 'b', required: true },
	{ id: 'q10', type: 'rating', section: 'b', required: true, skippable: true },
	{ id: 'q21', type: 'rating', section: 'b', required: true },
	{ id: 'q22', type: 'rating', section: 'b', required: true, skippable: true },
	// C. 개선·요청
	{ id: 'q11', type: 'text', section: 'c', required: true, maxLen: 500 },
	{ id: 'q12', type: 'multi', section: 'c', required: false, options: ['schedule', 'poll', 'taskcheck', 'video', 'external', 'email', 'approval', 'erp', 'other'], other: true },
	{ id: 'q13', type: 'rating', section: 'c', required: true },
	{ id: 'q14', type: 'nps', section: 'c', required: true },
	{ id: 'q24', type: 'text', section: 'c', required: false, maxLen: 300 },
	// D. 효과·방향
	{ id: 'q25', type: 'single', section: 'd', required: true, options: ['much_faster', 'faster', 'same', 'worse'] },
	{ id: 'q26', type: 'single', section: 'd', required: true, options: ['none', 'm10', 'm30', 'h1', 'h1p'] },
	{ id: 'q27', type: 'rating', section: 'd', required: false, scale: 'agree' },
	{ id: 'q28', type: 'single', section: 'd', required: true, options: ['stability', 'mobile', 'integration', 'collab', 'ai', 'i18n', 'video'] },
	{ id: 'q29', type: 'single', section: 'd', required: true, options: ['big_problem', 'some', 'no_matter'] },
	{ id: 'q15', type: 'text', section: 'd', required: false, maxLen: 1000 },
];

export const SURVEY_SECTIONS = ['a', 'b', 'c', 'd'] as const;

/** q26 선택지 → 대표 분(서버 surveySchema.TIME_SAVED_MINUTES 와 동일) — 관리자 KPI "절약 분/일" */
export const TIME_SAVED_MINUTES: Record<string, number> = { none: 0, m10: 5, m30: 20, h1: 45, h1p: 75 };
